<template>
    <a-modal width="55%" :title="titlePrefix" :visible="visible" centered :destroy-on-close="true"
             :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24, 8]">
<!--                <a-col :span="24">
                    <a-form-item label="头像" name="headShot">
                        <img-upload v-model:value="form.headShot"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="姓名" name="name">
                        <a-input v-model:value="form.name" placeholder="请输入"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="身份证号码" name="idCard">
                        <a-input v-model:value="form.idCard" disabled placeholder="请输入"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系电话" name="phoneNumber">
                        <a-input v-model:value="form.phoneNumber" disabled placeholder="请输入"/>
                    </a-form-item>
                </a-col>

                <a-col :span="12">
                    <a-form-item label="职称" name="positional">
                        <a-input v-model:value="form.positional" placeholder="请输入职称"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="工作单位" name="workUnit">
                        <a-input v-model:value="form.workUnit" placeholder="请输入工作单位"/>
                    </a-form-item>
                </a-col>

                <a-col :span="12">
                    <a-form-item label="身份证(PDF)" name="idCardFile">
                        <FileUpload v-model:value="form.idCardFile" is-pdf="true" :multiple="false" :size="50"
                                    :count="1"></FileUpload>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="职称证书(PDF)" name="positionalFile">
                        <FileUpload names="职称证书" v-model:value="form.positionalFile" is-pdf="true" :multiple="false"
                                    :size="50" :count="1"></FileUpload>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="专家库成员申请表(PDF)" name="applyFile">
                        <FileUpload v-model:value="form.applyFile" is-pdf="true" :multiple="false" :size="50"
                                    :count="1"></FileUpload>
                        <div style="margin-top: 8px" v-if="!form.applyFile">
                            <a @click="downloadApplyFile" alt="阳泉高新区信息化项目评审专家库成员申请表">点击下载《阳泉高新区信息化项目评审专家库成员申请表》</a>
                            <span style="color: red">填写并盖章后上传扫描文件</span>
                        </div>
                    </a-form-item>
                </a-col>-->
                <a-col :span="12">
                    <a-form-item label="个人签名(图片)" name="signatureFile">
<!--                        <img-upload names="个人签名" v-model:value="form.signatureFile" :multiple="false"
                                    :size="50" :count="1"></img-upload>-->
                        <user-sign :file-id="form.signatureFile" @finish="changeSign"></user-sign>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="签名样例">
                        <img src="@/assets/svg/签名.png" alt="签名模板">
                    </a-form-item>
                </a-col>
                <a-divider/>
                <a-col :span="12">
                    <a-form-item label="银行账号" name="bankAccount">
                        <a-input v-model:value="form.bankAccount" placeholder="请输入银行账号"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="银行名称" name="bankName">
                        <a-input v-model:value="form.bankName" placeholder="请输入银行名称"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="行号" name="bankNo">
                        <a-input v-model:value="form.bankNo" placeholder="请输入行号"/>
                    </a-form-item>
                </a-col>
                <!--                <a-col :span="24">
                                    <a-form-item label="银行卡(PDF)" name="bankFile">
                                        <FileUpload names="银行卡" v-model:value="form.bankFile" is-pdf="true" :multiple="false" :size="50" :count="1"></FileUpload>
                                    </a-form-item>
                                </a-col>-->
            </a-row>
            <!--可编辑区域 end-->
        </a-form>
    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {expert} from "@/api/projectReviewService";
import {file_service} from "@/api/adminService";
import axios from "axios";
import UserSign from "./userSign.vue";

export default {
    name: "UserModal",
    components: {UserSign},
    mixins: [formMixin],
    data() {
        return {
            form: {
                id: null,
            },
            rules: {
                id: [],
                // headShot: [],
                // name: [dataCheck.required({})],
                // phoneNumber: [dataCheck.required({}), dataCheck.mobile_phone,],
                // idCard: [dataCheck.required({})
                //     , dataCheck.id_num
                // ],
                // credentials:[],
                // workUnit: [dataCheck.required({msg: "请输入工作单位"})],
                // positional: [dataCheck.required({msg: "请输入职称"})],
                // applyFile: [dataCheck.required({msg: "请上传专家库成员申请表"})],
                // idCardFile: [dataCheck.required({msg: "请上传身份证"})],
                // positionalFile: [dataCheck.required({msg: "请上传职称证书"})],
                bankAccount: [dataCheck.required({msg: "请输入银行账号"})],
                bankName: [dataCheck.required({msg: "请输入银行名称"})],
                bankNo: [dataCheck.required({msg: "请输入行号"})],
                bankFile: [dataCheck.required({msg: "请上传银行卡复印件"})],
                signatureFile: [dataCheck.required({msg: "请上传个人签名图片"})],
            },
            submitUrl: expert.save,
        }
    },
    methods: {
        downloadApplyFile() {
            axios({
                methods: 'get',
                url: file_service.download + 'a1r1ueave9xsp5eyfhhv|阳泉高新区信息化项目评审专家库成员申请表.docx',
            }).then(() => {
                const link = document.createElement("a"); // 创建a标签
                link.href = file_service.download + "a1r1ueave9xsp5eyfhhv|阳泉高新区信息化项目评审专家库成员申请表.docx";
                link.target = '_blank';
                link.download = decodeURIComponent("阳泉高新区信息化项目评审专家库成员申请表.docx");// 文件重命名，若无需重命名，将该行删去
                link.click();
            })
        },
        changeSign(val){
            this.form.signatureFile = val
        }
    }
}
</script>
<style scoped lang="less"></style>
